<div [formGroup]="form" class="py-2">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Tipo endereço</mat-label>
      <mat-select formControlName="addressType">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>CEP</mat-label>
      <input
        matInput
        (input)="getAddressByPostalCode()"
        (blur)="getAddressByPostalCode()"
        formControlName="postalCode"
      />
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Latitude</mat-label>
      <input matInput formControlName="latitude" />
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Longitude</mat-label>
      <input matInput formControlName="longitude" />
    </mat-form-field>
  </div>

  <div class="flex justify-between gap-4 items-center">
    <mat-form-field class="input-tg w-7/12" appearance="outline">
      <mat-label>Logradouro</mat-label>
      <input matInput formControlName="street" />
    </mat-form-field>

    <mat-form-field class="input-tg w-2/12" appearance="outline">
      <mat-label>Número</mat-label>
      <input matInput formControlName="number" />
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Bairro</mat-label>
      <input matInput formControlName="neighborhood" />
    </mat-form-field>
  </div>

  <div class="flex justify-between gap-4 items-center">
    <mat-form-field class="input-tg w-4/12" appearance="outline">
      <mat-label>Complemento</mat-label>
      <input matInput formControlName="complement" />
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Cidade</mat-label>
      <input matInput formControlName="city" />
    </mat-form-field>

    <mat-form-field class="input-tg w-3/12" appearance="outline">
      <mat-label>Estado</mat-label>
      <input matInput formControlName="state" />
    </mat-form-field>

    <mat-form-field class="input-tg w-2/12" appearance="outline">
      <mat-label>País</mat-label>
      <input matInput formControlName="country" />
    </mat-form-field>
  </div>

  <div class="flex justify-end gap-4 items-center">
    <button mat-flat-button class="btn-tg w-1/12" (click)="cancel()">
      Cancel
    </button>
    @if (this.editItem.idCreate != undefined) {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="editAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Editar
        }
      </button>
    } @else {
      <button
        mat-flat-button
        class="btn-tg w-1/12"
        [disabled]="form.invalid || loading"
        (click)="createAddress()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    }
  </div>
</div>
